import { css } from 'lit';
import componentStyles from '../../../styles/component.styles';
import { theme } from '../../../themes/theme';
export default css `
    ${componentStyles}

    .card {
        ${theme.spacings.cssPaddingX('XS')};
        ${theme.spacings.cssPaddingY('S')};
        cursor: pointer;
    }

    .name {
        ${theme.texts.cssBody('bold')};
        ${theme.colors.cssColor('text-primary')};
    }

    .description {
        ${theme.texts.cssBody('light')};
        ${theme.colors.cssColor('gray-500')};
    }
`;
//# sourceMappingURL=result-card.styles.js.map